var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.tipology == 'promoter')?_c('PromoterCardEdit',{attrs:{"id":_vm.id}}):(_vm.tipology == 'ambassador')?_c('AmbassadorCardEdit',{attrs:{"id":_vm.id}}):_c('div',{staticClass:"title is-1"},[_vm._v("😓")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }